module.exports = __webpack_public_path__ + "89aff2c66afe20ff645f144de72bd7b7.ttf";